import { Table,  Button, Pagination } from "flowbite-react";
import { HiPlus, HiPencil } from "react-icons/hi";
import { useNavigate } from 'react-router-dom';
import { useReducerAsState } from "../hooks/useReducerAsState";
import { routes } from "../routes";
import useProfiles from "../hooks/useProfiles";
import { useEffect } from "react";
import { TableResults } from "../components";
import { useAuth } from "../context/authContext";


interface State {
    loading: boolean;
    page: number;
    limit: number;
}

const ProfilesPage = () => {
    const { permissions } = useAuth()

    const canCreate = permissions.find(item => item.slug === 'crear-perfiles')
    const canEdit = permissions.find(item => item.slug === 'editar-perfiles')
    
    const { profiles, loading, error, totalProfiles, fetchProfiles } = useProfiles();

    const [state, setState] = useReducerAsState<State>({
        limit: 10,
        page: 1,
        loading: false
    })

    const navigate = useNavigate();

    const onPageChange = (page: number) => setState({page})

    const handleCreate = () => navigate(`${routes.DASHBOARD}/${routes.PROFILES}/create`)

    useEffect(() => {
        (async () => {
            await fetchProfiles({
                page: state.page,
                limit: 10
            })
        })()
        // eslint-disable-next-line
    },[state.page])

    return <div className="m-4">
        <div className="flex flex-col mb-4">
            <div className="mb-4">
                <h1>Perfiles</h1>
            </div>
            <div className="flex flex-row justify-between items-end">
                <div className="flex flex-row">
                    {canCreate && <Button onClick={handleCreate}>
                        <HiPlus className="mr-2 h-5 w-5" />
                        Crear perfíl
                    </Button>}
                </div>
            </div>
        </div>
        <TableResults
            loading={loading}
            error={error}
            itemsCount={totalProfiles}
        >
            <div className="overflow-x-auto mb-4 w-full bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                <Table>
                    <Table.Head>
                        <Table.HeadCell>Nombre</Table.HeadCell>
                        <Table.HeadCell>
                            <span className="sr-only">Editar</span>
                        </Table.HeadCell>
                    </Table.Head>
                    <Table.Body className="divide-y">
                        {profiles && profiles.map((item) => <Table.Row key={item.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                            <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                            {item.title}
                            </Table.Cell>
                            <Table.Cell>
                                {canEdit && <Button color="gray" onClick={() => navigate(`${routes.DASHBOARD}/${routes.PROFILES}/${item.id}`)}>
                                    <HiPencil />
                                </Button>}
                            </Table.Cell>
                        </Table.Row>)}
                    </Table.Body>
                </Table>
            </div>
        </TableResults>
        {profiles && <div className="flex overflow-x-auto sm:justify-center">
                <Pagination currentPage={state.page} totalPages={Math.ceil(totalProfiles / state.limit)} onPageChange={onPageChange} />
            </div>
        }
    </div>
}

export default ProfilesPage;